import { confidenceClass, percent } from '../utils/format';

/**
 * The little bar + percentage pair used in every table. Markup matches the Razor version so
 * the .confidence-bar rules in site.css apply unchanged.
 */
export function ConfidenceBar({ value }: { value: number }) {
  return (
    <div className="d-flex align-items-center gap-2">
      <div className="confidence-bar">
        <div
          className={`confidence-bar-fill ${confidenceClass(value)}`}
          style={{ width: `${percent(value)}%` }}
        />
      </div>
      <small>{percent(value)}%</small>
    </div>
  );
}
